import { AfterViewInit, Component, OnDestroy, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { EquipmentModel, Equipment } from "src/app/equipment/equipment";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { Subscription } from "rxjs";
import { Seasons, SeasonsEntity } from "src/app/equipment/seasons";
import { MatSnackBar } from "@angular/material";
import { GlobalConstants } from "src/app/shared/constants/constants";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-equipment-form",
  templateUrl: "./equipment-form.component.html",
  styleUrls: ["./equipment-form.component.css"],
})
export class EquipmentFormComponent implements OnDestroy, AfterViewInit {
  @ViewChild("equipmentForm") equipmentForm: NgForm;
  private subscription$ = new Subscription();
  showLoader: boolean = false;
  furnacemn: boolean;

  equipment: EquipmentModel;
  seasons: SeasonsEntity[];
  fanTypes: string[] = GlobalConstants.fanTypes;
  compressorTypes: string[] = GlobalConstants.compressorTypes;
  selectedSeason: string | number = "";
  equipmentEditMode: boolean = false;
  selectedRegion: string;
  isShowSeasonSection: boolean = true;
  color = GlobalConstants.ProgressBar.color;
  mode = GlobalConstants.ProgressBar.mode;
  bufferValue = GlobalConstants.ProgressBar.bufferValue;
  progresBarValue: number;
  constructor(
    private equipmentService: EquipmentService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {
    this.getSeasons();
    this.equipment = new EquipmentModel();
    this.equipment.compressortype = "";
    this.equipment.fanspeed = "";
    this.equipment.ratercompid = "0";
    this.selectedRegion = "";
    this.equipment.fanspeed = "";
    this.route.queryParams.subscribe((queryParams) => {
      this.equipmentEditMode = queryParams?.id ? true : false;
      this.equipmentEditMode ? this.getEquipmentById(queryParams.id) : "";
    });
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.validateInputs();
    }, 1000);
  }

  /**
   * Saving Equipment
   */
  save() {
    if (
      this.equipment?.furnacemn?.length &&
      !this.equipment?.furnmfre?.length
    ) {
      return;
    } else if (
      !this.equipment?.furnacemn?.length &&
      this.equipment?.furnmfre?.length
    ) {
      return;
    }
    this.showLoader = true;
    let operation = this.equipmentEditMode
      ? "updateExisitngEquipment"
      : "addNewEquipment";
    this.subscription$.add(
      this.equipmentService[operation](this.equipment).subscribe(
        () => {
          this.showLoader = false;
          this.router.navigate(["/equipment"]);
          this.snackBar.open(
            `${this.equipmentEditMode
              ? "Equipment Updated Sucessfully"
              : "Equipment Created Sucessfully"
            } `,
            "",
            {
              duration: 2000,
            }
          );
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(
            `${this.equipmentEditMode
              ? "Error in Updating Equipment"
              : "Error in Creating Equipment"
            }`,
            "",
            {
              duration: 2000,
            }
          );
        }
      )
    );
  }

  /**
   * Get Equipment Details By Id
   */

  getEquipmentById(equipmentId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getSingleEquipment(equipmentId).subscribe(
        (result: Equipment) => {
          if (result?.Equipment.length) {
            this.equipment = result.Equipment[0];
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Equipment Details. `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Get Seasons
   * @param equipmentId
   */
  getSeasons() {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getSeasons().subscribe(
        (result: Seasons) => {
          if (result?.Seasons?.length) {
            this.seasons = result.Seasons;
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Seasons. `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Change Selected Season
   */
  changeSeason() {
    if (this.selectedSeason != "") {
      let season = this.seasons.find(
        (season) => season.temp_id == this.selectedSeason
      );
      this.equipment.ratercompid = season.hdd_cdd;
      this.selectedRegion = season.county + " - " + season.state;
    } else {
      this.equipment.ratercompid = "0";
      this.selectedRegion = "";
    }
  }

  /**
   * Show Hide HDD or CDD
   */
  showHideHDDCDD() {
    if (this.isShowSeasonSection) {
      this.equipment.ratercompid = "0";
      this.selectedRegion = "";
      this.selectedSeason = "";
      this.isShowSeasonSection = false;
    } else {
      this.isShowSeasonSection = true;
    }
  }
/**
   * validate input fields and show progress bar
   */

  validateInputs() {
    let inputCount = 0;
    Object.keys(this.equipmentForm?.controls).map((field) => {
      if (this.equipmentForm?.controls[field]?.value) inputCount++;
    });
    this.progresBarValue =
      (inputCount / Object.keys(this.equipmentForm?.controls).length) * 100;
  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
